( function( app ) {
  const COMPONENT = {
    init: function() {
      document.querySelectorAll( '[data-component="vc-cta"]' ).forEach( function( section ) {
        const cards = section.querySelectorAll( '.vc-cta__card' );
        if ( cards.length === 0 ) return;

        cards.forEach( function( card ) {
          card.style.position = 'static';
          card.style.display = 'inline-block';
        } );

        const maxWidth = Array.from( cards ).reduce( function( max, card ) {
          return Math.max( max, card.offsetWidth );
        }, 0 );

        cards.forEach( function( card ) {
          card.style.position = 'absolute';
          card.style.display = '';
          card.style.width = maxWidth + 'px';
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'vc-cta', COMPONENT );
} )( app );
